'use strict';

require('../users/CompanyUserStarService.js');

function CompanyPublicationsListStarredCtrl(
  $scope,
  $stateParams,
  $state,
  publications,
  translations
) {
  $scope.publications = publications;
  $scope.$state = $state;
  $scope.more = false;
  $scope.title = translations['publication.starred'];

  if($scope.publications.length === 21) {
    $scope.more = true;
    $scope.publications.pop();
  }

  $scope.page = $stateParams.page|0;
  $scope.companyId = $stateParams.companyId;
  $scope.listStarred = true;

  $scope.filter = {};
  if ($stateParams.queryStarred) {
    $scope.filter.q = $stateParams.queryStarred;
  }

  $scope.searchPublications = function() {
    $state.go('.', {
      companyId: $stateParams.companyId,
      queryStarred: $scope.filter.q
    });
  };

}

CompanyPublicationsListStarredCtrl.resolve = {
  publications: ['$stateParams', 'CurrentUserService', 'CompanyUserStarService', function($stateParams, CurrentUserService, CompanyUserStarService) {
    return CurrentUserService.get().then(function(user) {
      var companyId = $stateParams.companyId,
      filter = {};

      filter.companyId = companyId;
      filter.userId = user.id;
      // Fetch 21 for pagination, but the offset should be using 20
      filter.limit = 21;
      filter.offset = ($stateParams.page|0) * 20;
      filter.q = $stateParams.queryStarred || null;

      return CompanyUserStarService.query(filter).$promise;
    });
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'publication.list-starred',
      'publication.starred'
    ]);
  }]
};
module.exports = CompanyPublicationsListStarredCtrl;

angular.module('dokiv')
  .controller('CompanyPublicationsListStarredCtrl', [
    '$scope',
    '$stateParams',
    '$state',
    'publications',
    'translations',
    CompanyPublicationsListStarredCtrl
  ]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/CompanyPublicationsListStarredCtrl.js
// module id = 387
// module chunks = 0